import Vue from 'vue'
import VueSocketIO from 'vue-socket.io'
import Multiselect from 'vue-multiselect'
import CxltToastr from 'cxlt-vue2-toastr'
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'
import './components';
import './plugins';
import { sync } from 'vuex-router-sync';
import App from './App';
import i18n from '@/i18n';
import router from '@/router';
import store from '@/store';
// import fullscreen from 'vue-fullscreen'
// import '@/plugins/registerServiceWorker'
import VueHtml2Canvas from 'vue-html2canvas';
import VueNativeNotification from 'vue-native-notification';

var toastrConfigs = {
    position: 'top left',
    showDuration: 400
};

Vue.use(CxltToastr, toastrConfigs);
// Vue.use(fullscreen)
Vue.use(VuejsDialog);
Vue.use(VueHtml2Canvas);

window.axios = require('axios');
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel);

window.axios.defaults.baseURL = 'https://testapiback.customerservice.uz/api/';
//window.axios.defaults.baseURL = 'https://dev.customerservice.uz/api/';
// window.axios.defaults.baseURL = 'http://127.0.0.1:8001/api/';


if (typeof Storage !== "undefined") {
    let UserToken = localStorage.getItem('token');
    if (UserToken) {
        window.axios.defaults.headers.common['Authorization'] = `Bearer ${UserToken}`;
    }
    // window.axios.defaults.headers.common['localization'] = (localStorage.getItem('language')) ? ;
}

try {
    Notification.requestPermission()
        .then(() => {
        });
    Vue.use(VueNativeNotification, {
        requestOnNotify: true
    });
} catch (error) {

}

sync(store, router);

Vue.config.productionTip = false;

Vue.component('multiselect', Multiselect)

Vue.filter('numberWithSpaces', (data) => {

    if (data || data == 0)
        return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
});

Vue.filter('dateTime', (mysql_string) => {
    var t, result = null;
    if (typeof mysql_string === 'string') {
        t = mysql_string.split(/[- :]/);
    }
    return (t[2] || 0) + '.' + (t[1] || 0) + '.' + (t[0] || 0) + ' ' + (t[3] || 0) + ':' + (t[4] || 0);
});

Vue.use(new VueSocketIO({
    debug: false,
    connection: 'https://testapiback.customerservice.uz:443',
}));

const app = new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app');


window.axios.interceptors.request.use(
    (config) => {

        return config
    },
    (error) => {
        return Promise.reject(error);
    }
);

window.axios.interceptors.response.use(

    (response) => {
        let UserToken = localStorage.getItem('token');
        if (UserToken) {
            window.axios.defaults.headers.common['Authorization'] = `Bearer ${UserToken}`;
        }
        setTimeout(() => {
            app.$store.commit('SET_ISLOGIN', true);
        }, 100);

        return response;
    },
    (error) => {

        if (error.response.status == '401') {
            localStorage.clear();
            app.$store.commit('SET_ISLOGIN', false);

        }

        if (error.response.status == '429') {
            app.$toast.error({
                title: 'Ошибка сервера',
                message: 'Вы заблокированы на несколько минут, из-за большого ' +
                    'количества запросов на сервер '
            });
        }

        if (error.response.status == '500') {
            app.$toast.error({
                title: 'Ошибка сервера',
                message: 'Обратитесь администратору сайта '
            });
        }
        return Promise.reject(error);
    }
);
